/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Loader,
  Icon,
  Popup,
  PopupHeader,
  PopupContent,
} from 'semantic-ui-react';
import $ from 'jquery';
import cx from 'classnames';
import cloneDeep from 'lodash/cloneDeep';
import Chart from 'chart.js/auto';
import moreBtn from '../../images/components/content_project_card/newRisk.png';
import scanFailIcon from '../../images/components/content_project_card/scan_fail_ic.png';
import scanQueue from '../../images/components/content_project_card/scanning_ic.png';
import quickScan from '../../images/components/content_project_card/quickScan.png';
import jsBundled from '../../images/icons/parcel.png';
import MoreOptionsMenu from '../Extensions/MoreOptionsMenu';

class UploadedFileCard extends Component {
  constructor(props) {
    super(props);
    this.chart = null;
    this.state = {
      isSelectable: props.isSelectable,
      checkValues: props.checkValues,
      isMenuOpen: false,
    };
    this.menuRef = React.createRef();
  }

  componentDidMount() {
    const { file } = this.props;
    if (this.miniBarChart && file.scanStatus === 2) {
      this.drawMiniBarChart();
    }
    if (this.bubbleChart && file.scanStatus === 2) {
      this.drawBubbleChart();
    }
    if (this.pieChart && file.scanStatus === 2) {
      this.drawChart();
    }
    $(document).on('mouseover', '.content_project_card .name', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
    $(document).on('mouseover', '.content_project_card .right_value', function () {
      const $this = $(this);
      if (!$this.attr('title')) {
        $this.attr('title', 'SCAN DURATION');
      }
    });
    document.addEventListener('mousedown', this.handleClickOutside, true);
  }

  componentDidUpdate(prevProps) {
    const { file, isSelectable, checkValues } = this.props;
    if (prevProps.file.scanStatus !== file.scanStatus) {
      if (file.scanStatus === 2) {
        this.drawMiniBarChart();
        this.drawBubbleChart();
      }
    }

    if (prevProps.isSelectable !== isSelectable) {
      this.setState({
        isSelectable,
      });
    }

    if (prevProps.checkValues.length !== checkValues.length) {
      this.setState({
        checkValues,
      });
    }

    if (prevProps.file.componentCount.total !== file.componentCount.total) {
      this.drawChart();
    }
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
    document.removeEventListener('mousedown', this.handleClickOutside, true);
  }

  handleClick = () => {
    const { file, clickEvent } = this.props;
    clickEvent(file.uid);
  };

  handleChangeView = (e, string) => {
    const { file, handleChangeView } = this.props;
    handleChangeView(file.uid, string);
  };

  handleCheckChange = (e) => {
    const { file, isSelectable, handleCheckChange } = this.props;
    if (!isSelectable || !file.hasPermission) {
      return;
    }
    handleCheckChange(e, { value: file.uid });
  };

  handleCardBookmarkChange = (ufid, is_bookmark) => {
    const { handleCardBookmarkChange } = this.props;
    handleCardBookmarkChange(ufid, is_bookmark);
  };

  handleClickOutside = (event) => {
    if (this.menuRef.current && !this.menuRef.current.contains(event.target)) {
      this.setState({
        isMenuOpen: false
      });
    }
  };

  handleIssueCallback = (uid) => {
    const { handleIssueCallback } = this.props;
    handleIssueCallback(uid);
  };

  handleToggleMenu = () => {
    this.setState((prevState) => {
      return {
        isMenuOpen: !prevState.isMenuOpen
      };
    });
  };

  handleCloseMenu = () => {
    this.setState({
      isMenuOpen: false
    });
  };

  handleSaveCallback = () => {
    const { handleSaveCallback } = this.props;
    handleSaveCallback();
  };

  setCompareItem = (rowData) => {
    const { setCompareItem } = this.props;
    this.setState({
      isMenuOpen: false,
    });
    setCompareItem(rowData);
  };

  updateFilePath = (obj, id) => {
    const { updateFilePath } = this.props;
    console.log(updateFilePath);
    updateFilePath(obj, id);
  };

  rescanReport = (uid) => {
    const { rescanReport } = this.props;
    this.setState({
      isMenuOpen: false,
    });
    rescanReport(uid);
  };

  refreshSecurityReport = (uid) => {
    const { refreshSecurityReport } = this.props;
    this.setState({
      isMenuOpen: false,
    });
    refreshSecurityReport(uid);
  };

  findMaxIndex = (arr) => {
    const allEqual = arr.every((item) => {
      return item === arr[0];
    });
    if (allEqual) {
      return null;
    }
    const maxValue = Math.max(...arr);
    const maxIndex = arr.findIndex((value) => {
      return maxValue === value;
    });
    return maxIndex;
  };

  findMinIndex = (arr) => {
    const allEqual = arr.every((item) => {
      return item === arr[0];
    });
    if (allEqual) {
      return null;
    }
    const minValue = Math.min(...arr);
    const minIndex = arr.findIndex((value) => {
      return minValue === value;
    });
    return minIndex;
  };

  deletedCallback = (uid) => {
    const { deletedCallback } = this.props;
    deletedCallback(uid);
  };

  abbreviateNumber = (value) => {
    let newValue = value;
    if (value >= 10000) {
      const suffixes = ['', 'K', 'M', 'B', 'T'];
      const suffixNum = Math.floor(` ${value}`.length / 4);
      let shortValue = '';
      let i = 4; //precision
      for (i; i >= 1; i--) {
        shortValue = parseFloat(
          (suffixNum !== 0 ? value / (1000 ** suffixNum) : value).toPrecision(i) // prettier-ignore
        ); // ** : Math.pow()
        const dotLessShortValue = `${shortValue} `.replace(/[^a-zA-Z 0-9]+/g, '');
        if (dotLessShortValue.length <= 4) {
          break;
        }
      }
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  };

  drawChart = () => {
    const { file } = this.props;
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }

    if (this.pieChart) {
      const config = {
        type: 'doughnut',
        data: {
          datasets: [
            {
              data: [
                file.componentCount.has_risk,
                file.componentCount.total - file.componentCount.has_risk,
              ],
              backgroundColor: ['#ff7d45', '#F4F4F4'],
              hoverOffset: 4,
            },
          ],
        },
        options: {
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
          },
        }
      };

      const ctx = this.pieChart.getContext('2d');
      this.chart = new Chart(ctx, config);
    }
  };

  drawMiniBarChart = () => {
    const { file } = this.props;
    const realData = file.securityCount;
    const dummyData = cloneDeep(realData);
    delete dummyData.total;
    const arr = Object.keys(dummyData).map((i) => {
      return dummyData[i];
    });

    const indexOfMax = this.findMaxIndex(arr);
    if (arr[indexOfMax] !== 0) {
      const dataRatio = arr.map((value) => {
        return (value / arr[indexOfMax]) * 100;
      });
      let i = 0;
      for (i; i < this.miniBarChart.childNodes.length; i++) {
        this.miniBarChart.childNodes[i].style.width = `${dataRatio[i]}%`;
      }
    }
  };

  drawBubbleChart = () => {
    const { file } = this.props;
    const realData = file.licenseCount;
    if (realData.total !== 0) {
      const dummyData = cloneDeep(realData);
      delete dummyData.total;
      const array = Object.keys(dummyData).map((i) => {
        return dummyData[i];
      });
      const indexOfMax = this.findMaxIndex(array);
      const indexOfMin = this.findMinIndex(array);
      let duplicateMax;
      let duplicateMin;

      //duplicate check
      array.filter((item, index) => {
        if (index !== indexOfMax && array[index] === array[indexOfMax]) {
          duplicateMax = index;
          return duplicateMax;
        }
        return false;
      });

      array.filter((item, index) => {
        if (index !== indexOfMin && array[index] === array[indexOfMin]) {
          duplicateMin = index;
          return duplicateMin;
        }
        return false;
      });

      if (duplicateMax) {
        let otherIdx;
        array.filter((item, index) => {
          if (index !== indexOfMax && index !== duplicateMax) {
            otherIdx = index;
            return otherIdx;
          }
          return false;
        });
        this.bubbleChart.childNodes[indexOfMax].childNodes[0].style.width = '100%';
        this.bubbleChart.childNodes[indexOfMax].childNodes[0].style.height = '100%';
        this.bubbleChart.childNodes[duplicateMax].childNodes[0].style.width = '100%';
        this.bubbleChart.childNodes[duplicateMax].childNodes[0].style.height = '100%';
        this.bubbleChart.childNodes[otherIdx].childNodes[0].style.width = '50%';
        this.bubbleChart.childNodes[otherIdx].childNodes[0].style.height = '50%';
      } else if (duplicateMin) {
        let otherIdx;
        array.filter((item, index) => {
          if (index !== indexOfMin && index !== duplicateMin) {
            otherIdx = index;
            return otherIdx;
          }
          return false;
        });
        this.bubbleChart.childNodes[otherIdx].childNodes[0].style.width = '100%';
        this.bubbleChart.childNodes[otherIdx].childNodes[0].style.height = '100%';
        this.bubbleChart.childNodes[duplicateMin].childNodes[0].style.width = '50%';
        this.bubbleChart.childNodes[duplicateMin].childNodes[0].style.height = '50%';
        this.bubbleChart.childNodes[indexOfMin].childNodes[0].style.width = '50%';
        this.bubbleChart.childNodes[indexOfMin].childNodes[0].style.height = '50%';
      } else if (indexOfMax === null && indexOfMin === null) {
        this.bubbleChart.childNodes[0].childNodes[0].style.width = '75%';
        this.bubbleChart.childNodes[0].childNodes[0].style.height = '75%';
        this.bubbleChart.childNodes[1].childNodes[0].style.width = '75%';
        this.bubbleChart.childNodes[1].childNodes[0].style.height = '75%';
        this.bubbleChart.childNodes[2].childNodes[0].style.width = '75%';
        this.bubbleChart.childNodes[2].childNodes[0].style.height = '75%';
      } else {
        let otherIdx;
        array.filter((item, index) => {
          if (index !== indexOfMin && index !== indexOfMax) {
            otherIdx = index;
            return otherIdx;
          }
          return false;
        });
        this.bubbleChart.childNodes[indexOfMax].childNodes[0].style.width = '100%';
        this.bubbleChart.childNodes[indexOfMax].childNodes[0].style.height = '100%';
        this.bubbleChart.childNodes[otherIdx].childNodes[0].style.width = '75%';
        this.bubbleChart.childNodes[otherIdx].childNodes[0].style.height = '75%';
        this.bubbleChart.childNodes[indexOfMin].childNodes[0].style.width = '50%';
        this.bubbleChart.childNodes[indexOfMin].childNodes[0].style.height = '50%';
      }
    } else {
      this.bubbleChart.childNodes[0].childNodes[0].style.width = '50%'; // red
      this.bubbleChart.childNodes[0].childNodes[0].style.height = '50%';
      this.bubbleChart.childNodes[1].childNodes[0].style.width = '50%'; //orange
      this.bubbleChart.childNodes[1].childNodes[0].style.height = '50%';
      this.bubbleChart.childNodes[2].childNodes[0].style.width = '50%'; //yellow
      this.bubbleChart.childNodes[2].childNodes[0].style.height = '50%';
    }
  };

  renderScanStatus = () => {
    const { translate, file } = this.props;
    const { scanStatus, scanStatusDetail } = file;
    if (scanStatus === 0) {
      return (
        <div className="status_wrapper">
          <img src={scanQueue} alt="" />
          <span className="text">{translate('contents_header.menu.queue')}</span>
        </div>
      );
    } if (scanStatus === 1) {
      return (
        <div>
          <Loader active size="large" />
          <div className="scan_detail">
            <h5 style={{ fontWeight: '500' }}>{scanStatusDetail}</h5>
          </div>
        </div>
      );
    } if (scanStatus === 3) {
      return (
        <div className="status_wrapper">
          <img src={scanFailIcon} alt="" />
          <span className="text">{translate('modal.title.scan_failed')}</span>
        </div>
      );
    }
  };

  render() {
    const humanReadable = (seconds) => {
      const pad = (x) => {
        return x < 10 ? '0'.concat(x) : ''.concat(x);
      };
      return pad(parseInt(seconds / (60 * 60), 10)).concat(
        ':',
        pad(parseInt((seconds / 60) % 60, 10)),
        ':',
        pad(seconds % 60)
      ); // eslint-disable-line no-unused-vars
    };

    const getItemStyle = (isDragging, draggableStyle) => {
      return {
        //userSelect: 'none',
        //background: isDragging && '#fae7ff',
        opacity: isDragging && 0.6,
        ...draggableStyle,
      };
    };

    const {
      translate,
      file,
      draggableProvided,
      draggableSnapshot,
      state,
      location,
    } = this.props;
    const {
      scanStatus,
      useScanOption,
      hasBundled,
      uid,
      isLowMemoryWaiting,
    } = file;
    const {
      isSelectable,
      checkValues,
      isMenuOpen,
    } = this.state;

    return (
      <div
        className="content_project_card_box content_file_card"
      >
        <div
          className={cx(
            'content_project_card',
            {
              select_mode: isSelectable,
            },
            {
              active: checkValues.indexOf(uid) > -1,
            },
            {
              low_memory_status: isLowMemoryWaiting,
            },
            {
              more_menu_show: isMenuOpen,
            }
          )}
          ref={draggableProvided.innerRef}
          {...draggableProvided.draggableProps}
          {...draggableProvided.dragHandleProps}
          style={getItemStyle(
            draggableSnapshot.isDragging,
            draggableProvided.draggableProps.style
          )}
          onClick={this.handleCheckChange}
        >
          <div className="content_project_card_inner">
            {
              checkValues.indexOf(uid) > -1
              && <span className="active_mode"><Icon name="check" /></span>
            }
            <div className="content_project_card_header">
              {
                scanStatus === 2 && (file.componentCountBroad && file.componentCountBroad.total !== 0) ? (
                  <div
                    className="name has_link"
                    onClick={this.handleClick}
                  >
                    {useScanOption ? (<img src={quickScan} alt="" />) : null}
                    {hasBundled ? (<img src={jsBundled} alt="" />) : null}
                    <span>{file.name}</span>
                  </div>
                ) : (
                  <div
                    className="name"
                    style={{ color: '#b9b9b9' }}
                  >
                    { useScanOption ? (<img src={quickScan} alt="" />) : null}
                    {hasBundled ? (<img src={jsBundled} alt="" />) : null}
                    <span>{file.name}</span>

                  </div>
                )
              }
              <div className="os">
                {file.projectName}
                {' '}
                /
                {' '}
                {file.projectVersionName}
              </div>
              <div className="more" onClick={this.handleToggleMenu}>
                <a>
                  <img src={moreBtn} alt="more" />
                </a>
              </div>
              <MoreOptionsMenu
                state={state}
                rowData={file}
                translate={translate}
                menuRef={this.menuRef}
                location={location}
                updateFilePath={this.updateFilePath}
                handleCardBookmarkChange={this.handleCardBookmarkChange}
                handleIssueCallback={this.handleIssueCallback}
                handleSaveCallback={this.handleSaveCallback}
                rescanReport={this.rescanReport}
                refreshSecurityReport={this.refreshSecurityReport}
                deletedCallback={this.deletedCallback}
                setCompareItem={this.setCompareItem}
                closeMenu={this.handleCloseMenu}
              />
            </div>
            <div className="content_project_card_content">
              {file.scanStatus !== 2 ? (
                this.renderScanStatus()
              ) : (
                <div className="content_project_card_content_inner">
                  {file.componentCountBroad.total && file.componentCountBroad.total !== 0 ? (
                    <div
                      className="card_content"
                    >
                      <div
                        className="card_content_item has_link"
                        onClick={this.handleClick}
                      >
                        <p className="label">{translate('card.menu.grade')}</p>
                        {
                          file.uploadedGrade === '-' ? (
                            <div className="rank">{file.uploadedGrade}</div>
                          ) : (
                            <Popup
                              className="grade_info"
                              trigger={<div className="rank">{file.uploadedGrade}</div>}
                              inverted
                            >
                              <PopupHeader>
                                <Icon name="info circle" />
                                {file.uploadedGrade === 'A' && translate('panel.menu.info_grade_a_title')}
                                {file.uploadedGrade === 'B' && translate('panel.menu.info_grade_b_title')}
                                {file.uploadedGrade === 'C' && translate('panel.menu.info_grade_c_title')}
                                {file.uploadedGrade === 'D' && translate('panel.menu.info_grade_d_title')}
                              </PopupHeader>
                              <PopupContent>
                                {file.uploadedGrade === 'A' && translate('panel.menu.info_grade_a')}
                                {file.uploadedGrade === 'B' && translate('panel.menu.info_grade_b')}
                                {file.uploadedGrade === 'C' && translate('panel.menu.info_grade_c')}
                                {file.uploadedGrade === 'D' && translate('panel.menu.info_grade_d')}
                              </PopupContent>
                            </Popup>
                          )
                        }
                      </div>
                      {
                        file.securityCountBroad.total !== 0 ? (
                          <div
                            className="card_content_item  has_link"
                            onClick={(e) => { return this.handleChangeView(e, 'security'); }}
                          >
                            <p className="label">{translate('card.menu.security')}</p>
                            <div className="mini_bar_chart_wrap">
                              <p className="value">
                                {this.abbreviateNumber(file.securityCount.total)}
                                {file.hasExploit ? (<Icon name="bug" />) : null}
                              </p>
                              <div
                                className="mini_bar_chart"
                                ref={(ref) => {
                                  this.miniBarChart = ref;
                                }}
                              >
                                <div style={{ width: '0%' }} />
                                <div style={{ width: '0%' }} />
                                <div style={{ width: '0%' }} />
                                <div style={{ width: '0%' }} />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div
                            className="card_content_item"
                            style={{ pointerEvents: 'none' }}
                          >
                            <p className="label">{translate('card.menu.security')}</p>
                            <div className="mini_bar_chart_wrap">
                              <p className="value">
                                {this.abbreviateNumber(file.securityCount.total)}
                              </p>
                              <div
                                className="mini_bar_chart"
                                ref={(ref) => {
                                  this.miniBarChart = ref;
                                }}
                              >
                                <div style={{ width: '0%' }} />
                                <div style={{ width: '0%' }} />
                                <div style={{ width: '0%' }} />
                                <div style={{ width: '0%' }} />
                              </div>
                            </div>
                          </div>
                        )
                      }
                      {
                        file.componentCountBroad.total !== 0 ? (
                          <div
                            className="card_content_item  has_link"
                            onClick={(e) => { return this.handleChangeView(e, 'component'); }}
                          >
                            <p className="label">{translate('card.menu.component')}</p>
                            <div className="pie_chart_wrap">
                              <span className="value">
                                {this.abbreviateNumber(file.componentCount.total)}
                              </span>
                              <canvas
                                ref={(ref) => {
                                  this.pieChart = ref;
                                }}
                              />
                            </div>
                          </div>
                        ) : (
                          <div
                            className="card_content_item"
                            style={{ pointerEvents: 'none' }}
                          >
                            <p className="label">{translate('card.menu.component')}</p>
                            <div className="pie_chart_wrap">
                              <span className="value">
                                {this.abbreviateNumber(file.componentCount.total)}
                              </span>
                              <canvas
                                ref={(ref) => {
                                  this.pieChart = ref;
                                }}
                              />
                            </div>
                          </div>
                        )
                      }
                      {
                        file.licenseCountBroad.total !== 0 ? (
                          <div
                            className="card_content_item  has_link"
                            onClick={(e) => { return this.handleChangeView(e, 'license'); }}
                          >
                            <p className="label">{translate('card.menu.license')}</p>
                            <div className="mini_bubble_chart_wrap">
                              <p className="value">
                                {this.abbreviateNumber(file.licenseCount.total)}
                              </p>
                              <div
                                className="bubble_chart"
                                ref={(ref) => {
                                  this.bubbleChart = ref;
                                }}
                              >
                                <div>
                                  {/** red*/}
                                  <div className="inner" style={{ width: '0%', height: '0%' }} />
                                </div>
                                <div>
                                  {/** orange*/}
                                  <div className="inner" style={{ width: '0%', height: '0%' }} />
                                </div>
                                <div>
                                  {/** yellow*/}
                                  <div className="inner" style={{ width: '0%', height: '0%' }} />
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div
                            className="card_content_item"
                            style={{ pointerEvents: 'none' }}
                          >
                            <p className="label">{translate('card.menu.license')}</p>
                            <div className="mini_bubble_chart_wrap">
                              <p className="value">
                                {this.abbreviateNumber(file.licenseCount.total)}
                              </p>
                              <div
                                className="bubble_chart"
                                ref={(ref) => {
                                  this.bubbleChart = ref;
                                }}
                              >
                                <div>
                                  {/** red*/}
                                  <div className="inner" style={{ width: '0%', height: '0%' }} />
                                </div>
                                <div>
                                  {/** orange*/}
                                  <div className="inner" style={{ width: '0%', height: '0%' }} />
                                </div>
                                <div>
                                  {/** yellow*/}
                                  <div className="inner" style={{ width: '0%', height: '0%' }} />
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      }
                      <div className="bottom_value_wrap">
                        {
                          file.policyCountBroad !== 0 ? (
                            <div
                              className="left_value value purpple"
                              onClick={(e) => { return this.handleChangeView(e, 'policy'); }}
                            >
                              {file.policyCount}
                              <em>{translate('card.menu.policy')}</em>
                            </div>
                          ) : (
                            <div
                              className="left_value value grey"
                              style={{ pointerEvents: 'none' }}
                            >
                              {file.policyCount}
                              <em>{translate('card.menu.policy')}</em>
                            </div>
                          )
                        }
                        <div className="right_value value grey">
                          {humanReadable(file.scannedTime)}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="card_content" style={{ pointerEvents: 'none' }}>
                      <div className="card_content_item">
                        <p className="label">{translate('card.menu.grade')}</p>
                        <div className="rank">{file.uploadedGrade || '-'}</div>
                      </div>
                      <div className="card_content_item">
                        <p className="label">{translate('card.menu.security')}</p>
                        <div className="mini_bar_chart_wrap">
                          <p className="value">{file.securityCount.total || 0}</p>
                          <div
                            className="mini_bar_chart"
                            ref={(ref) => {
                              this.miniBarChart = ref;
                            }}
                          >
                            <div style={{ width: '0%' }} />
                            <div style={{ width: '0%' }} />
                            <div style={{ width: '0%' }} />
                            <div style={{ width: '0%' }} />
                          </div>
                        </div>
                      </div>
                      <div className="card_content_item">
                        <p className="label">{translate('card.menu.component')}</p>
                        <div className="pie_chart_wrap">
                          <span className="value">{file.componentCount.total || 0}</span>
                          <canvas
                            ref={(ref) => {
                              this.pieChart = ref;
                            }}
                          />
                        </div>
                      </div>
                      <div className="card_content_item">
                        <p className="label">{translate('card.menu.license_uppercase')}</p>
                        <div className="mini_bubble_chart_wrap">
                          <p className="value">{file.licenseCount.total || 0}</p>
                          <div
                            className="bubble_chart"
                            ref={(ref) => {
                              this.bubbleChart = ref;
                            }}
                          >
                            <div>
                              {/** red*/}
                              <div className="inner" style={{ width: '0%', height: '0%' }} />
                            </div>
                            <div>
                              {/** orange*/}
                              <div className="inner" style={{ width: '0%', height: '0%' }} />
                            </div>
                            <div>
                              {/** yellow*/}
                              <div className="inner" style={{ width: '0%', height: '0%' }} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="bottom_value_wrap">
                        <div className="left_value value grey">
                          {file.policyCount || 0}
                          <em>{translate('card.menu.policy')}</em>
                        </div>
                        <div className="right_value value grey">
                          {humanReadable(file.scannedTime)}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="content_project_card_footer">
              <p className="time">{file.uploadedDate}</p>
              <p className="name">{file.owner}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
UploadedFileCard.defaultProps = {
  file: {},
};
export default inject('state')(observer(UploadedFileCard));
